import { SimpleHead } from './Head';
import { MainStatic } from './Main';

export const NotFound = () => (
    <section className="p-16">
        <div className="text-center my-64">
            <h1>404</h1>
            <p>På FINN finner du alt … bortsett fra denne siden.</p>
            <p>
                <a href="https://www.finn.no/" data-testid="frontpageLink">
                    Gå til forsiden
                </a>
            </p>
        </div>
        <img src="https://www.finn.no/assets/404.jpg" alt="Katt som holder en FINN-annonse" data-testid="errorImage" />
    </section>
);

export const NotFoundPage = () => (
    <>
        {/* @ts-expect-error missing canonical as error page cannot have that, i.e. it can be shown for any url */}
        <SimpleHead title="404 | FINN reise" description="Vi kunne dessverre ikke finne denne siden." />
        <MainStatic>
            <NotFound />
        </MainStatic>
    </>
);
